// Mock data for enseQure Incorporation website

export const companyInfo = {
  name: "enseQure Incorporation",
  tagline: "Securing Your Digital Future",
  description: "Leading IT Infrastructure, Cybersecurity, and Cloud Solutions Provider across Africa and Europe",
  email: "info@ensequre.com",
  phone: "+263 242 123 456",
  locations: [
    { city: "Harare", country: "Zimbabwe", address: "Number 10 Hillview Road, Philadelphia, Harare" },
    { city: "Johannesburg", country: "South Africa", address: "Sandton City, Johannesburg, South Africa" },
    { city: "Prague", country: "Czechia", address: "Peroutkova 570/83, Prague, Czechia" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Cybersecurity Services",
    shortDesc: "Comprehensive security solutions to protect your digital assets",
    description: "Our cybersecurity experts provide end-to-end security solutions including threat assessment, penetration testing, security auditing, and 24/7 monitoring to safeguard your organization against cyber threats.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc2OTUzMzM5MXww&ixlib=rb-4.1.0&q=85",
    features: ["Threat Assessment", "Penetration Testing", "Security Auditing", "24/7 Monitoring", "Incident Response"]
  },
  {
    id: 2,
    title: "Cloud Consultancy",
    shortDesc: "Strategic cloud solutions with AWS, Azure, Oracle & Google Cloud",
    description: "Transform your business with our cloud consulting services. We help you leverage AWS, Microsoft Azure, Oracle Cloud, and Google Cloud Platform to build scalable, reliable, and cost-effective cloud infrastructure.",
    icon: "Cloud",
    image: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3Njk1MzMzOTZ8MA&ixlib=rb-4.1.0&q=85",
    features: ["AWS Solutions", "Microsoft Azure", "Oracle Cloud", "Google Cloud Platform", "Cloud Migration"]
  },
  {
    id: 3,
    title: "System Integration",
    shortDesc: "Seamless integration with payment gateways and enterprise systems",
    description: "We specialize in integrating your systems with leading payment gateways including Stripe, PayPal, Paynow, GPay, and many more. Our integration services ensure seamless connectivity between your applications and third-party services.",
    icon: "Link",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    features: ["Stripe Integration", "PayPal Integration", "Paynow", "Google Pay", "API Development"]
  },
  {
    id: 4,
    title: "Fintech Solutions",
    shortDesc: "Innovative technology solutions for financial institutions",
    description: "We develop cutting-edge fintech solutions that help banks and financial institutions streamline operations, enhance customer experience, and stay compliant with regulations.",
    icon: "Landmark",
    image: "https://images.unsplash.com/photo-1736751035793-353baaa416cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxmaW50ZWNoJTIwYmFua2luZ3xlbnwwfHx8fDE3Njk1MzM0MDF8MA&ixlib=rb-4.1.0&q=85",
    features: ["Payment Systems", "Digital Banking", "Regulatory Compliance", "Fraud Detection", "API Integration"]
  },
  {
    id: 5,
    title: "AI & ChatBot Development",
    shortDesc: "Intelligent automation with AI and WhatsApp ChatBots",
    description: "Harness the power of Artificial Intelligence to automate your business processes. We develop intelligent ChatBots for WhatsApp and other platforms to enhance customer engagement and support.",
    icon: "Bot",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    features: ["WhatsApp ChatBots", "AI Automation", "Natural Language Processing", "Customer Support Bots", "Business Intelligence"]
  },
  {
    id: 6,
    title: "Custom Software Development",
    shortDesc: "School, Learning & Membership Management Systems",
    description: "We develop comprehensive management systems tailored to your needs. Our solutions include School Management Systems, Learning Management Systems (LMS), and Membership Management Systems with full customization.",
    icon: "Code",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    features: ["School Management", "Learning Management (LMS)", "Membership Systems", "Custom Portals", "Mobile Apps"]
  },
  {
    id: 7,
    title: "Virtualization & Kubernetes",
    shortDesc: "Container orchestration and virtualization solutions",
    description: "Transform your infrastructure with enterprise virtualization and Kubernetes container orchestration. We design, implement, and manage scalable containerized environments for modern applications.",
    icon: "Container",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc2OTUzMzQwN3ww&ixlib=rb-4.1.0&q=85",
    features: ["Kubernetes", "OpenShift", "Docker", "VMware", "Container Security"]
  },
  {
    id: 8,
    title: "DevSecOps",
    shortDesc: "Integrate security into your development lifecycle",
    description: "Our DevSecOps services embed security practices throughout the software development lifecycle, ensuring faster, more secure deployments with automated security testing.",
    icon: "GitBranch",
    image: "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc2OTUzMzM5MXww&ixlib=rb-4.1.0&q=85",
    features: ["CI/CD Security", "Container Security", "Code Analysis", "Compliance Automation", "Security Training"]
  },
  {
    id: 9,
    title: "IT Infrastructure",
    shortDesc: "Build robust and scalable IT infrastructure",
    description: "From enterprise networks to data centers, we design, implement, and manage IT infrastructure that supports your business growth and ensures operational excellence.",
    icon: "Server",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc2OTUzMzQwN3ww&ixlib=rb-4.1.0&q=85",
    features: ["Network Design", "Data Center", "Storage Solutions", "Enterprise Networks", "Disaster Recovery"]
  },
  {
    id: 10,
    title: "Managed Services",
    shortDesc: "24/7 IT management and support services",
    description: "Let our experts manage your IT operations with proactive monitoring, maintenance, and support services that keep your systems running at peak performance.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3Njk0NDk3MzZ8MA&ixlib=rb-4.1.0&q=85",
    features: ["Infrastructure Management", "Network Operations", "Application Support", "Cloud Operations", "Service Reporting"]
  }
];

export const staffingServices = [
  {
    id: 1,
    title: "IT Administrator as a Service",
    description: "Experienced IT administrators to manage your infrastructure, user support, and system maintenance.",
    icon: "UserCog"
  },
  {
    id: 2,
    title: "Cloud Engineer as a Service",
    description: "Certified cloud engineers for AWS, Azure, and GCP to design and manage your cloud environment.",
    icon: "CloudCog"
  },
  {
    id: 3,
    title: "DevOps Engineer as a Service",
    description: "Expert DevOps engineers to automate your CI/CD pipelines and optimize delivery workflows.",
    icon: "Cog"
  },
  {
    id: 4,
    title: "IT Architect as a Service",
    description: "Senior IT architects to design enterprise solutions and technology roadmaps.",
    icon: "Building2"
  }
];

export const stats = [
  { value: "500+", label: "Clients Served" },
  { value: "15+", label: "Years Experience" },
  { value: "99.9%", label: "Uptime SLA" },
  { value: "24/7", label: "Support Available" }
];

export const partners = [
  {
    name: "AWS",
    badge: "ASEAN Consulting Partner of the Year 2017",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
  },
  {
    name: "Microsoft Azure",
    badge: "Hybrid Cloud Partner of the Year 2017",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg"
  },
  {
    name: "Oracle Cloud",
    badge: "Cloud Solutions Partner",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg"
  },
  {
    name: "Google Cloud",
    badge: "Cloud Platform Partner",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg"
  },
  {
    name: "Red Hat",
    badge: "OpenShift Partner",
    logo: "https://upload.wikimedia.org/wikipedia/commons/d/d8/Red_Hat_logo.svg"
  },
  {
    name: "VMware",
    badge: "Virtualization Partner",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Vmware.svg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "James Moyo",
    role: "CTO, First National Bank Zimbabwe",
    content: "enseQure transformed our IT infrastructure with their cloud migration expertise. Their team's professionalism and technical knowledge exceeded our expectations.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Sarah Ndlovu",
    role: "Head of IT, Standard Chartered SA",
    content: "The cybersecurity services provided by enseQure have significantly improved our security posture. Their 24/7 monitoring gives us peace of mind.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "David Chikwanda",
    role: "CEO, TechVentures Africa",
    content: "Working with enseQure on our DevSecOps implementation was a game-changer. They helped us achieve faster deployments without compromising security.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  }
];

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "Services", href: "/services" },
  { name: "About", href: "/about" },
  { name: "Contact", href: "/contact" }
];
